import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { pointActions } from '../../store/modules/point';
import PointIssueHistoryListWrap from '../../views/point/issueHistory/list/PointIssueHistoryListWrap/PointIssueHIstoryListWrap';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import {
  POINT_ISSUE_HISTORY_LIST_SEARCH_DATA_MODEL,
  POINT_ISSUE_HISTORY_LIST_SEARCH_OPTION_MODEL,
} from '../../store/modules/point/models';

class PointIssueHistoryListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: POINT_ISSUE_HISTORY_LIST_SEARCH_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['pointIssueHistoryList', 'searchData'],
      value: POINT_ISSUE_HISTORY_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = (data) => {
    const { getPointIssueHistoryList, pointIssueHistoryList } = this.props;
    const { searchOption, pagination } = pointIssueHistoryList;

    getPointIssueHistoryList({
      searchOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { pointIssueHistoryList, setData, adminSelectList } = this.props;

    return (
      <PointIssueHistoryListWrap
        pointIssueHistoryList={pointIssueHistoryList}
        setData={setData}
        adminSelectList={adminSelectList}
        getList={this.getList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pointIssueHistoryList: state.point.pointIssueHistoryList,
    adminSelectList: state.point.adminSelectList,
  };
};

const mapDispatchToProps = {
  setData: pointActions.setData,
  getPointIssueHistoryList: pointActions.getPointIssueHistoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PointIssueHistoryListContainer));
